import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  ref: "mainContainer",
  class: "relative grid gap-16 md:gap-40"
}
const _hoisted_2 = {
  key: 0,
  class: "hidden md:block absolute inset-y-0 left-0 2xl:ml-[41px]"
}
const _hoisted_3 = {
  ref: "stickyYear",
  class: "sticky top-40 z-1 min-w-[4ch] tabular-nums bg-white text-black-800 md:text-history-year-tablet xl:text-history-year-desktop font-semibold"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = {
  key: 0,
  class: "flip flip-in mt-[-1lh]"
}
const _hoisted_6 = {
  key: 0,
  ref: "timeline",
  class: "hidden 2xl:block absolute inset-y-0 p-4 border-e border-black-200 text-para-xs"
}
const _hoisted_7 = { class: "sticky top-40" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "invisible group-hover:visible" }
const _hoisted_10 = {
  key: 1,
  ref: "timelineMobile",
  class: "2xl:hidden fixed top-full inset-x-0 md:w-120 md:mx-auto p-2 bg-black-50 md:bg-transparent opacity-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$props.editMode && $data.stickyYearVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString($data.activeYear), 1),
              (_openBlock(), _createElementBlock("div", {
                key: $data.stickyAnimationKey,
                "aria-hidden": "true",
                class: _normalizeClass({ flipped: $data.stickyFlipped })
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'flip flip-out': $options.showStickyFlip })
                }, _toDisplayString($data.stickyFrontYear), 3),
                ($options.showStickyFlip)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($data.activeYear), 1))
                  : _createCommentVNode("", true)
              ], 2))
            ], 512)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 512),
    (!$props.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.years, (year) => {
              return (_openBlock(), _createElementBlock("button", {
                key: year,
                class: "group w-18 flex items-center gap-1.5",
                onClick: ($event: any) => ($options.scrollTo(year))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["border-b transition-all", {
                        'w-15 border-primary-500': $data.activeYear === year,
                        'w-8 border-black-400 group-hover:border-black-900': $data.activeYear !== year,
                    }])
                }, null, 2),
                _createElementVNode("span", _hoisted_9, _toDisplayString($data.activeYear === year ? ' ' : year), 1)
              ], 8, _hoisted_8))
            }), 128))
          ])
        ], 512))
      : _createCommentVNode("", true),
    (!$props.editMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_dropdown, {
            white: true,
            upward: true,
            modelValue: $data.activeYear,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.activeYear) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.years, (year) => {
                return (_openBlock(), _createBlock(_component_dropdown_item, {
                  key: `${year}-mobile`,
                  value: year,
                  label: year,
                  onGcItemSelected: ($event: any) => ($options.scrollTo(year))
                }, null, 8, ["value", "label", "onGcItemSelected"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}